// import apiCall from '../utils/api'
import Vue from 'vue'

const state = {
  status: '',
  hasLoadedOnce: false
}

const getters = {
  isAuthenticated: state => state.status === 'success' && !!window.getCookie('token'),
  token: state => {
    let token = window.getCookie('token')
    if (!token || token === 'undefined') token = ''
    return token
  },
  authStatus: state => state.status
}

const actions = {
  AUTH_REQUEST: ({ commit, dispatch }, user) => {
    return new Promise((resolve, reject) => {
      dispatch('CLEAR')
      commit('AUTH_REQUEST')
      delete Vue.axios.defaults.headers.common['Authorization']
      setTimeout(() => {
        Vue.axios
          .post(Vue.apiUrl('login'), Vue.toURLSearchParams(user), {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              Authorization: ''
            }
          })
          .then(resp => {
            commit('AUTH_SUCCESS', resp.data.Token)
            dispatch('USER_REQUEST', resp.data)
            resolve(resp)
          })
          .catch(error => {
            commit('AUTH_LOGOUT')
            commit('AUTH_ERROR', error)
            reject(error.message)
          })
      }, 500)
    })
  },
  AUTH_UPDATE: ({ getters, commit }, token) => {
    if (getters.isAuthenticated && token && getters.isProfileLoaded) {
      commit('AUTH_SUCCESS', token)
    }
  },
  AUTH_CHECK: ({ getters, commit, dispatch }) => {
    commit('AUTH_REQUEST')
    setTimeout(() => {
      if (getters.token && getters.isProfileLoaded) {
        commit('AUTH_SUCCESS', getters.token)
      } else commit('AUTH_LOGOUT')
    }, 100)
  },
  AUTH_LOGOUT: ({ commit, dispatch }) => {
    dispatch('api/RESET')
    dispatch('CLEAR')
    commit('AUTH_LOGOUT')
  },
  CLEAR: ({ commit, dispatch }) => {
    delete Vue.axios.defaults.headers['Authorization']
    delete Vue.axios.defaults.headers.common['Authorization']
    dispatch('api/INIT_CONFIG')
    dispatch('entities/CLEAR_ALL')
    window.createCookie('token', '', '; Expires=Thu, 01 Jan 1970 00:00:01 GMT')
    removeCache()
  }
}

const mutations = {
  AUTH_REQUEST: state => {
    Vue.set(state, 'status', 'loading')
  },
  AUTH_SUCCESS: (state, token) => {
    if (token && token !== 'undefined') {
      window.createCookie('token', token, 30)
      Vue.axios.defaults.headers.common.Authorization = token
      Vue.set(state, 'status', 'success')
    } else Vue.set(state, 'status', 'token error')
  },
  AUTH_ERROR: (state, error) => {
    Vue.set(state, 'status', error)
    Vue.set(state, 'hasLoadedOnce', true)
  },
  AUTH_LOGOUT: state => {
    Vue.set(state, 'status', '')
    Vue.set(state, 'hasLoadedOnce', true)
  }
}

function removeCache () {
  window.createCookie('token', '', '; Expires=Thu, 01 Jan 1970 00:00:01 GMT')
  window.localStorage.removeItem('vuex')
  window.sessionStorage.removeItem('Cliente')
  window.sessionStorage.removeItem('Instalacion')
  window.sessionStorage.removeItem('Estado')
  window.sessionStorage.removeItem('TecnicoAsignado')
  window.sessionStorage.removeItem('Programa')
  window.sessionStorage.removeItem('incidencias')
  window.sessionStorage.removeItem('serverPagination')

  // localStorage.clear()
  sessionStorage.clear()
  var cookies = document.cookie.split(';')
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i]
    var eqPos = cookie.indexOf('=')
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
  }
  delete Vue.axios.defaults.headers.common['Authorization']
}

export default {
  // namespaced: true,
  state,
  getters,
  actions,
  mutations
}
